module.exports = __webpack_public_path__ + "img/zhuanl6.12cf8e16.png";